import apiUrl from '../../../constants'
import axios from 'axios'
import iptrackerdetailsv2 from '../../../iptrackerdetails'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'userdetails',
    components: {
        Paginate,
        VueElementLoading,
        Multiselect
    },
    data: function() {
        return {
            listUserData: [],
            hubServiceCenterList:[],
            props: [],
            pageno: 0,
            pagecount: 1,
            username: '',
            userid: '',
            hubid:'',
            isLoading: false,
            resultCount: '',
            mobilenumber:'',
            status: "",
            userstatus: "",
            count: 0,
            email: '',
            localuserid: 0,
            listUserTypeData: [],
            utype:"",
            iptrackData:''
        }
    },
    created: function() {

    },
    async mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail;
        let iptrck= await iptrackerdetailsv2.checkUserIPV2(this.iptrackData,'UserDetails',this.$route.path);
        //console.log(iptrck);
        if(iptrck){
          this.$router.push('/');
        }
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;
        this.pageno = 0;
        //this.getUserDetail();
        this.getUserTypeData();
        this.getHubServiceCenterData();
    },
    methods: {
        searchUserData() {
          this.pageno = 0;
          this.$refs.paginate.selected = 0;
          this.getUserDetail();
        },
        //to get pagination
        getPaginationData(pageNum) {
            this.pageno = (pageNum - 1) * 10
            this.getUserDetail()
        },
        getStatusRowData(data) {
            this.userid = data.userid
            this.status = data.status
            if (data.status == true) {
                this.changestatus = 'De-Activate'
            } else {
                this.changestatus = 'Activate'
            }
        },
        resetForm() {
            this.username = '';
            this.mobilenumber = '';
            this.email = '';
            this.utype = '';
            this.userstatus = '';
            this.hubid = '';
            this.pageno = 0;
            this.pagecount = 1;
            this.$refs.paginate.selected = 0;
            this.resultCount=0;
            this.listUserData=0;
            this.exportlist=0;
        },

        //to get User Type list
        getUserTypeData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getusertypelist',
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.listUserTypeData = result.data.data.rows;
            }, error => {
              console.error(error)
            })
        },
        //to get Hub Service Center list
        getHubServiceCenterData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          this.input = {}
          axios({
              method: 'GET',
              url: apiUrl.api_url + 'external/gethubservicecenterlist',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              var data = [];
              result.data.hubs.data.forEach(function (hubData) {
                data.push({
                  id:hubData.HubID,
                  label:hubData.HubName + "("+hubData.HubID+")"
                });
              });
              this.hubServiceCenterList = data;
            }, error => {
              console.error(error)
            })
        },
        getUserDetail(){
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          this.input={
            offset: this.pageno,
            limit: 10,
            email: this.email,
            username:this.username,
            utype: this.utype,
            HubId: this.hubid.id,
            MobileNumber: this.mobilenumber,
            status: this.userstatus
          }
          this.isLoading = true;
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'getUserDetail',
            data: this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          }).then(result=>{
            this.listUserData = result.data.rows;
            for (var i = 0; i < this.listUserData.length; i++) {
              this.listUserData[i].password = (this.listUserData[i].password != '') ? this.listUserData[i].password : "Xpress@123"
            }
            this.isLoading = false;
            let totalRows = result.data.count
            this.resultCount = result.data.count
            if (totalRows < 10) {
                this.pagecount = 1
            } else {
                this.pagecount = Math.ceil(totalRows / 10)
            }
          })
        },
        exportToCSV(){
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          if(this.listUserData.length==undefined || this.listUserData.length==0)
          {
            this.$alertify.alert("No data to export");
          }
          else{
            this.input={
              email: this.email,
              username:this.username,
              utype: this.utype,
              HubId: this.hubid.id,
              MobileNumber: this.mobilenumber,
              status: this.userstatus
            }
            axios({
              method: 'POST',
              url: apiUrl.api_url + 'getExportDataToCSV',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            }).then(result=>{
              this.exportlist = result.data.rows;
              for (var i = 0; i < this.exportlist.length; i++) {
                this.exportlist[i].password = '"'+this.exportlist[i].password+'"'
              }
                this.downloadCSV(this.exportlist);
            })
          }


        },
      async  downloadCSV(result) {
          var csvData=result;
          var csvData = result;
          var today = new Date();
          var dd = today.getDate();
          var mm = today.getMonth() + 1;
          var yyyy = today.getFullYear();
          var today = dd + "" + mm + "" + yyyy;
          var data, filename, link;
          filename = "UserDetails" + today + ".csv";
          var csv = await this.convertArrayOfObjectsToCSV({
            data: csvData
          });
          if(csv == null) return;
          filename = filename || "export.csv";
          if(!csv.match(/^data:text\/csv/i)) {
            csv = "data:text/csv;charset=utf-8," + csv;
          }
          data = csv;
          link = document.createElement("a");
          link.setAttribute("href", data);
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
        },
        convertArrayOfObjectsToCSV: function(args) {
          var result, ctr, keys, columnDelimiter, lineDelimiter, data;
          data = args.data || null;
          if(data == null || !data.length) {
            return null;
          }
          columnDelimiter = args.columnDelimiter || ",";
          lineDelimiter = args.lineDelimiter || "\n";
          keys = Object.keys(data[0]).slice(0);
          result = "";
          result += keys.join(columnDelimiter);
          result += lineDelimiter;
          for(let i=0; i<data.length; i++){

              let password = encodeURIComponent(data[i].password)
              result += encodeURIComponent(data[i].userid)+','+data[i].OldDeliveryUserOrUserId+','+data[i].OutSourcingID+','+data[i].FirstName+','+data[i].LastName+','
              +data[i].username+','+data[i].email+','+data[i].MobileNumber+','+
              data[i].status+','+data[i].EntityType+','+password;
              result += lineDelimiter;


          }
          return result;
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/userdetails/userdetails.component.js